var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 6834"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 885",
    d: "M69.0579 78.8105C67.9807 77.7333 67.9807 75.9867 69.0579 74.9095L74.9095 69.0579C75.9867 67.9807 77.7333 67.9807 78.8105 69.0579L103.192 93.4395C104.269 94.5167 104.269 96.2633 103.192 97.3405L97.3405 103.192C96.2633 104.269 94.5167 104.269 93.4395 103.192L69.0579 78.8105Z",
    fill: "#A5AAAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.75 87.5C71.4942 87.5 87.5 71.4942 87.5 51.75C87.5 32.0058 71.4942 16 51.75 16C32.0058 16 16 32.0058 16 51.75C16 71.4942 32.0058 87.5 51.75 87.5ZM51.75 76.5C65.419 76.5 76.5 65.419 76.5 51.75C76.5 38.081 65.419 27 51.75 27C38.081 27 27 38.081 27 51.75C27 65.419 38.081 76.5 51.75 76.5Z",
    fill: "#C4C8C9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchCategory);
export default __webpack_public_path__ + "static/media/search-category.d91eb9770182faa23902fc9231f4670f.svg";
export { ForwardRef as ReactComponent };